export const ITEM_INFO_BOTTOM_PART_TRANSLATIONS = {
  type: 'panel.bottom-parts.single-item-bottom-part.type',
  size: 'panel.bottom-parts.single-item-bottom-part.size',
  resolution: 'panel.bottom-parts.single-item-bottom-part.resolution',
  createdAt: 'panel.bottom-parts.single-item-bottom-part.created-at',
  createdBy: 'panel.bottom-parts.single-item-bottom-part.created-by',
  duration: 'panel.bottom-parts.single-item-bottom-part.duration',
  bitrate: 'panel.bottom-parts.single-item-bottom-part.bitrate',
  url: 'panel.bottom-parts.single-item-bottom-part.url',
  copyUrl: 'panel.bottom-parts.single-item-bottom-part.copy-url',
  urlCopied: 'panel.bottom-parts.single-item-bottom-part.url-copied',
  sitesVisibility: 'panel.bottom-parts.single-item-bottom-part.sites-visibility.label',
  tagsPaid: 'panel.bottom-parts.single-item-bottom-part.source',
  madeWith: 'panel.bottom-parts.single-item-bottom-part.made-with',
};
